import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";

import {
  FooterSection,
  Title,
  Large,
} from "./styles";

const CopyRight =()=><p style={{margin: 0}}>©{(new Date()).getFullYear()} Mega Coders LLC</p>
function openEmail(){
  window.open(`
  mailto:MegaCodersLLC@gmail.com?subject=Business%20Inquiry&body=%20
  `)
}
const Footer = ({ t }: any) => {

  return (
    <>
      <FooterSection>

        <Container>
          <Row justify="space-between">
          <CopyRight />

            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Policy")}</Title>
              <Large to="/Privacy" left="true">
                {t("Privacy")}
              </Large>
              <Large to="/terms" left="true">
                {t("Terms of Use")}
              </Large>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Contact")}</Title>
              <Large to="/" onClick={openEmail} left="true">
                {t("MegaCodersLLC@gmail.com")}
              </Large>
            </Col>
          </Row>
        </Container>
      </FooterSection>
    </>
  );
};

export default withTranslation()(Footer);
